module.exports = __webpack_public_path__ + "media/点点消.de4a9781.mp4";